query getGameStatus(
  $manufacturer: String
  $supplier: String
  $free: Boolean
  $s: String
  $freegame: String
  $slug: String
  $exitUrl: String = ""
  $withoutInit: Boolean
) {
  gameInit(
    manufacturer: $manufacturer
    supplier: $supplier
    free: $free
    s: $s
    freegame: $freegame
    slug: $slug
    withoutInit: $withoutInit
    exitUrl: $exitUrl
  ) {
    game {
      gameId
      name
      slug
      compressedImage {
        webp {
          md
          lg
          xl
        }
      }
    }
    statusCode
    supplierStatusCode
  }
}
